import { render, staticRenderFns } from "./FilialMenuItem.vue?vue&type=template&id=1e484a7d&scoped=true&"
import script from "./FilialMenuItem.vue?vue&type=script&lang=js&"
export * from "./FilialMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./FilialMenuItem.vue?vue&type=style&index=0&id=1e484a7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e484a7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
